import { useMutation } from "react-query";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "fb";
import { toast } from "react-toastify";
import { InInUser } from "components/UserContext";

export const useUploadMutation = () => useMutation(async ({ user, file }: { user: InInUser, file: File }) => {
  // TODO: resize image
    const profileImageRef = ref(storage, `profiles/${user.uid}.png`);
    const metadata = {
      contentType: file.type,
    };
    const snapshot = await uploadBytes(profileImageRef, file, metadata);
    const downloadURL = await getDownloadURL(snapshot.ref);
    return downloadURL;
  }, {
    onError: (error) => {
      if (error instanceof Error) {
        toast.error(error.message);
      } else {
        throw error;
      }
    },
  });